/**
 * Check if the browser supports WebP
 * @returns {boolean}
 */
export const canUseWebP = (): boolean => {
  const elem = document.createElement('canvas')
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!(elem.getContext && elem.getContext('2d'))) {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp')
      .indexOf('data:image/webp') === 0
  }
  // very old browser like IE 8, canvas not supported
  return false
}

type SetCookieOptions = {
  minutesToExpire?: number
  path?: string
}

export const setBrowserCookie = (
  name: string,
  value: string,
  { minutesToExpire, path = '/' }: SetCookieOptions = {},
): void => {
  const expires = minutesToExpire
    ? `; expires=${new Date(Date.now() + minutesToExpire * 60 * 1000).toUTCString()}`
    : ''

  document.cookie = `${name}=${value}${expires}; path=${path}`
}
